<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import AddEdit from "./addedit.vue";
import menus from "@/models/menus";
import nestedDraggable from "./nested";

export default {
  mixins: [apibtoast, apigeneric, menus],
  page: {
    title: "Menü Yönetimi",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    AddEdit,
    nestedDraggable,
  },
  data() {
    return {
      title: this.$t("menus.Title"),
      items: [
        {
          text: this.$t("menus.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("menus.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("menus.Title"),
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
    };
  },
  methods: {
    Get() {
      this.ActionsFilterGet({ Service: "menus/gettree", 
      Page: this.Page,
       Filter: "&Asc=Dataorder&Websiteid="+window.$cookies.get("website")
        }).then(
        (res) => {
          this.TableData = res.Data;
          this.Page.PageDataSize = res.TotalCount;
        }
      );
    },
  },
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-12">
                  <div class="text-sm-end">
                    <button
                      type="button"
                      class="btn btn-primary btn-rounded mb-2 me-2"
                      v-b-modal.menus
                      @click="(DataUpdate = menusData), (AddEdit = 'Add')"
                    > 
                      <i class="mdi mdi-plus me-1"></i
                      >{{ $t("menus.Page.YeniKayitEkle") }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-8">
                  <nested-draggable :tasks="TableData" :TopId="null" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddEdit
        :Id="DataUpdate"
        :AddEdit="AddEdit"
        @TableUpdate="Get"
        v-show="DataUpdate"
      />
    </Layout>
  </Loader>
</template>
